import { AxiosResponse } from 'axios'
import { get } from '../../../methods'
import apiUrl from '../../../Url/ApiUrl'
import { PrefixType } from '../../../../redux/interfaces/Prefix'

export const getLanguages = <T>(prefix: PrefixType, cancelToken?): Promise<AxiosResponse<T>> => {
    if (prefix.includes('XTRF')) {
        return get({
            ...apiUrl.languages.xtrfLanguagesList,
            ...{ config: { ...apiUrl.languages.xtrfLanguagesList.config, ...{ cancelToken } } },
        })
    } else if (prefix === 'MEMSOURCE') {
        return get({
            ...apiUrl.languages.memsourceLanguagesList,
            ...{ config: { ...apiUrl.languages.memsourceLanguagesList.config, ...{ cancelToken } } },
        })
    }
}

export const getServices = <T>(): Promise<AxiosResponse<T>> => get(apiUrl.services.xtrfServicesList)

export const getSpecializations = <T>(): Promise<AxiosResponse<T>> =>
    get(apiUrl.specializations.xtrfSpecializationsList)

export const getSession = <T>(): Promise<AxiosResponse<T>> => get(apiUrl.system.xtrfSession)
